// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"b97ca195988ac0837323","114":"72df292d71c95a2ba521","115":"4151c14b5cc7cd4fd897","164":"29e7240a5e7f4bf60fab"}[chunkId] + ".chunk.js";
};